import csiAction from "csi/action";
import Popup from "csi/action/Popup";
import def from "csi/def";
import { Context } from "csi/def/Context";
import Ref from "csi/heading/Ref";
import html from "csi/html";
import locale from "csi/locale";
import csi from "csi/main";
import { TYPE_MATERIALDRAPE } from "csi/model/document";
import reflection from "csi/reflection";
import MaterialIcon from "csi/widget/MaterialIcon";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const ThreeDPlaceholder = declare(Ref, {
	bOmitFromExcel: true,

	/**
   * returns back the type of viewer to be used based on subtype
   * @param {Context} ctx
   */
	isMaterialViewer(ctx: Context): boolean {
		const subType = this._getDocumentSubtype(ctx);
		const revision = this._getRevision(ctx);

		if (!subType) {
			var node = ctx.getNode();
			if (!node) {
				return false;
			} else if (node.$Type == "Material" && node.Default3DMaterial != csi.EMPTY_URL) {
				return true;
			}
		}

		return subType == reflection.URL_SUBTYPE_UNIFIED_3D_MATERIAL && !revision.U3M_IsGroup;
	},

	/**
   * Adds title tag
   */
	toTooltip(ctx: Context, h: any, tooltip: any) {
		tooltip.addContent(html.create("div", {
			innerText: locale.resource("3DPreview"),
			style: "white-space: nowrap",
		}));

		this.inherited(arguments);
	},

	/**
   * There is no browse action for placeholder
   */
	_getAction() {
		return null;
	},

	/**
   * Return document node
   * @param {Context} ctx
   * @return {Node | undefined}
   */
	_getDocumentNode(ctx: Context) {
		var node = ctx.getNode();

		if (!node) {
			return;
		}

		if (node.$Type == "Document" || node.$Type == TYPE_MATERIALDRAPE) {
			return node;
		} else if (node.Default3DMaterial) {
			var doc = ctx.cache.getNode(node.Default3DMaterial);
			return doc;
		} else if (node.Default3DViewable) {
			var doc = ctx.cache.getNode(node.Default3DViewable);
			return doc;
		} else if (node.$Type == "DocumentRevision") {
			var parentNode = ctx.getNodeParent();
			return parentNode;
		}
	},

	/**
   * Return document subType
   * @param {Context} ctx
   */
	_getDocumentSubtype(ctx: Context) {
		var node = this._getDocumentNode(ctx);
		return node ? node.Subtype : false;
	},

	/**
   * Return document current revision
   * @param {Context} ctx
   */
	_getRevision(ctx: Context) {
		var node = ctx.getNode();
		if (node && (node.Default3DMaterial || node.Default3DViewable)) {
			var doc = this._getDocumentNode(ctx);
			return doc ? ctx.cache.getNode(doc.LatestRevision) : null;
		} else {
			return node;
		}
	},

	toHtmlStatic(ctx, h, refNode, actionData) {
		this.inherited(arguments);
		const { view } = ctx;
		const actionId = this.isMaterialViewer(ctx) ? "3DMaterialViewer": "3DViewer";
		
		if (!ctx.bExcel || !ctx.bPrint) {
			new MaterialIcon({
				icon: "3d_rotation",
				onClick: (): void => {
					const action = Object.assign(new Popup(), {
						classController: "csi/threeD/ViewerController",
						m_id: actionId,
						m_postAction: "postActionRefreshNode",
						m_typeControl: def.ACTION_ICON,
						dependencyPaths: ["Child:CurrentRevision"],
					});
					action.resolve();
					csiAction.invoke(view, refNode, action, {
						getTitle: () => h.getLabel(),
					});
				},
			})
				.placeAt(refNode);

			return true;
		}
		return false;
	},

});

export = ThreeDPlaceholder;
